import React, { Fragment } from 'react';

import { PrimarySearchForm } from '../PrimarySearchForm/PrimarySearchForm';
import { ResultTable } from '../ResultTable/ResultTable';

export const MainWrapper = ({
  data,
  onExport,
  onPageChange,
  onSortedChange,
  onSubmit,
  page,
  sorted
}) => (
  <Fragment>
    <PrimarySearchForm onSubmit={onSubmit} />
    {data && (
      <ResultTable
        data={data}
        onExport={onExport}
        onPageChange={onPageChange}
        onSortedChange={onSortedChange}
        page={page}
        sorted={sorted}
      />
    )}
  </Fragment>
);



// WEBPACK FOOTER //
// ./src/components/MainWrapper/MainWrapper.js